import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { MFA_CONTENT, MFA_HREFLANG } from "@/data/multilingual-mfa-content";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";

const C = MFA_CONTENT.ko;
const PATH = "/ko/mfa-legalisation";

export const Route = createFileRoute("/ko/mfa-legalisation")({
  head: () => ({
    meta: [
      { title: ctaTitle(C.h1, "/ko/mfa-legalisation", "th")},
      { name: "description", content: ctaDesc(C.intro.slice(0, 160), "/ko/mfa-legalisation", "th")},
      { property: "og:title", content: ctaTitle(C.h1, "/ko/mfa-legalisation", "th")},
      { property: "og:description", content: ctaDesc(C.intro.slice(0, 160), "/ko/mfa-legalisation", "th")},
      { property: "og:url", content: SEO_SITE + PATH },
      { property: "og:locale", content: "ko_KR" },
    ],
    links: [
      { rel: "canonical", href: SEO_SITE + PATH },
      ...Object.entries(MFA_HREFLANG).map(([k, v]) => ({
        rel: "alternate", hreflang: k === "th" ? "th-TH" : k === "en" ? "en" : k,
        href: SEO_SITE + v,
      })),
      { rel: "alternate", hreflang: "x-default", href: SEO_SITE + "/mfa-legalisation" },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "Service",
        name: C.h1, url: SEO_SITE + PATH, areaServed: "TH",
        inLanguage: "ko", serviceType: "Consular Legalization",
        provider: { "@type": "GovernmentService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ko",
        mainEntity: C.faqs.map((f) => ({
          "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
